<section class="authentication-section position-relative">
  <div class="login-nav d-flex justify-content-between">
    <div class="logo-holder">
      <a href="#"><img src="/img/logo.png" alt="Telq" /></a>
    </div>
    <ul class="menu-holder d-flex align-items-center">
      <li><a [routerLink]="['/registration']">Don't have an account?</a></li>
      <li><a [routerLink]="['/registration']" class="btn">Signup</a></li>
    </ul>
  </div>

  <div class="authentication-content container position-relative">
    <div class="authentication-box">
      <div class="authentication-form-wrapper">
        <app-login-form (login)="onLogin()" (changeStep)="onChangeStep($event)"></app-login-form>
        <div class="forgot-link text-center mt-20">
          <a *ngIf="step === 'login'" [routerLink]="['/reset-password']" class="text-primary font">I forgot my password</a>
          <a *ngIf="step === 'mfa' && mfaType === 'totp'" [routerLink]="['/reset-password']" [queryParams]="{ mfa: true, username: username }">
            Can't access your authentication app?
          </a>
        </div>
      </div>
      <div class="illustrations illustration1">
        <img src="/img/illustration1.svg" alt="illustration" />
      </div>
      <div class="illustrations illustration2">
        <img src="/img/illustration2.svg" alt="illustration" />
      </div>
      <div class="illustrations illustration3">
        <img src="/img/illustration3.svg" alt="illustration" />
      </div>
      <div class="illustrations illustration4">
        <img src="/img/illustration4.svg" alt="illustration" />
      </div>
    </div>
  </div>

  <copyright-note></copyright-note>
</section>
